<ul class="ml-2 nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'template' }" (click)="selectMenu('template')">Manage
      Template</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'send' }" (click)="selectMenu('send')">Send Marketing Emails</a>
  </li>
</ul>

<div class="row mt-3" *ngIf="selMenu == 'template'">
  <div class="col-3">
    <div class="form-group w-100 col-12">
      <label for="exampleInputEmail1">
        <h4>Email Template</h4>
      </label>
      <div class="d-flex" style="gap: 10px">
        <div class="d-flex">
          <select class="form-control" [(ngModel)]="selectTemplate" style="width: 15rem"
            (change)="setTemplate($event.target.value)" placeholder="Select Template">
            <option [value]="null" selected>Select Template Category</option>
            <option [value]="t?.id" *ngFor="let t of allTemplateList">{{ t?.templateName }}</option>
          </select>
          <span class="d-inline pl-2"><button type="button" (click)="reset()" title="Add New Email Template"
              class="btn btn-primary">
              <i class="fa fa-plus-circle" aria-hidden="true"></i></button></span>
          <span class="d-inline pl-2"><button (click)="remove()" type="button" title="Delete Email Template"
              class="btn btn-primary">
              <i class="fa fa-trash" aria-hidden="true"></i></button></span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-9">
    <form [formGroup]="form">
      <div class="row pl-3">
        <div class="form-group w-50">
          <label for="">Template Name *</label>
          <input type="text" formControlName="templateName" maxlength="100" class="form-control" />
        </div>
        <div class="form-group w-10 ml-5">
          <label for="">Region</label>
          <app-multi-dropdown class="input__field p-0 w-10 d-block" style="width: 200px !important"
            [placeholder]="selectedMemberRegion" [items]="allRegionList"
            (itemSelected)="onRegionClick($event)"></app-multi-dropdown>
        </div>
      </div>

      <div class="form-group w-50">
        <label for="">Email Subject *</label>
        <input type="text" formControlName="subject" maxlength="200" class="form-control" />
      </div>

      <div class="form-group">
        <label for="">Email Body *</label>
        <textarea row="10" class="form-control" maxlength="5000" formControlName="body" style="height: 250px"
          (change)="updatePreviewData()"></textarea>
      </div>

      <div class="form-group">
        <label for="">Email Footer *</label>
        <textarea row="5" class="form-control" maxlength="5000" formControlName="footer" style="height: 150px"
          (change)="updatePreviewData()"></textarea>
      </div>

      <div class="modal-footer">
        <button type="button" (click)="reset()" class="btn btn-secondary mr-2"><i class="fa-solid fa-plus"></i> Add New
          Template</button>
        <button class="btn btn-primary mr-2" (click)="sendTextMail(TestMail)" type="button"><i
            class="fa-solid fa-paper-plane"></i> Send test mail</button>

        <button class="btn btn-primary" (click)="saveTemplate()" type="button"><i class="fa-solid fa-save"></i> {{
          form.get("id").value ? "Update" : "Save" }}</button>
      </div>
    </form>
    <div class="preview mt-2">
      <p>Preview</p>
      <section style="width: 100%" [innerHtml]="previewEmailData"></section>
    </div>
  </div>
</div>

<div class="mt-3" *ngIf="selMenu == 'send'">
  <div class="row">
    <div class="col-3 bg-light">
      <section class="template-selection pt-2">
        <div class="form-group w-100 col-12">
          <label for="templateSelector" class="form-label">
            <h6>Region :-</h6>
          </label>
          <div class="d-flex flex-wrap gap-3">
            <app-multi-dropdown class="input__field p-0 w-10 d-block" style="width: 200px !important"
              [placeholder]="selectedMemberRegion" [items]="allRegionList"
              (itemSelected)="getRegionEmailTemplate($event)"></app-multi-dropdown>
          </div>
        </div>


        <div class="form-group w-100 col-12">
          <label for="templateSelector" class="form-label">
            <h6>Email Template :-</h6>
          </label>
          <div class="d-flex flex-wrap gap-3">
            <select id="templateSelector" class="form-control form-select w-100 w-md-50"
              (change)="formTemplateForSending($event.target.value)" aria-label="Select Email Template">
              <option [value]="null" selected>Select Email Template</option>
              <option [value]="i" *ngFor="let t of allSelectedTemplateList; let i = index">{{ t?.templateName }}
              </option>
            </select>
          </div>
        </div>

        <!-- <div class="form-group w-100 col-12">
					<label for="templateSelector" class="form-label">
						<h6>Product Type 1</h6>
					</label>
					<div class="d-flex flex-wrap gap-3">
						<select id="templateSelector" class="form-control form-select w-100 w-md-50" [(ngModel)]="productType1" aria-label="Select Email Template">
							<option [value]="null" selected>Select Product Type</option>
							<option value="biz">Biz</option>
							<option value="community">Community</option>
							<option value="shout-out">Shout Out</option>
						</select>
					</div>
				</div>

				<div class="form-group w-100 col-12">
					<label for="templateSelector" class="form-label">
						<h6>Product Type 2</h6>
					</label>
					<div class="d-flex flex-wrap gap-3">
						<select id="templateSelector" class="form-control form-select w-100 w-md-50" [(ngModel)]="productType2" aria-label="Select Email Template">
							<option [value]="null" selected>Select Product Type</option>
							<option value="biz">Biz</option>
							<option value="community">Community</option>
							<option value="shout-out">Shout Out</option>
						</select>
					</div>
				</div>

				<div class="form-group w-100 col-12">
					<label for="templateSelector" class="form-label">
						<h6>Product Type 3</h6>
					</label>
					<div class="d-flex flex-wrap gap-3">
						<select (change)="onTemplateChange($event)" id="templateSelector" class="form-control form-select w-100 w-md-50" [(ngModel)]="productType3" aria-label="Select Email Template">
							<option [value]="null" selected>Select Product Type</option>
							<option value="biz">Biz</option>
							<option value="community">Community</option>
							<option value="shout-out">Shout Out</option>
						</select>
					</div>
				</div> -->
        <div class="form-group w-100 col-12">
          <label for="templateSelector" class="form-label">
            <h6>Product Type</h6>
          </label>
          <div class="d-flex flex-wrap gap-3">
            <select (change)="onTemplateChange($event)" id="templateSelector"
              class="form-control form-select w-100 w-md-50" aria-label="Select Email Template">
              <option [value]="null" selected>Select Product Type</option>
              <option value="biz">Biz</option>
              <option value="community">Community</option>
              <option value="shout-out">Shout Out</option>
            </select>
          </div>
        </div>
        <div class="form-group w-100 col-12">
          <label for="templateSelector" class="form-label">
            <h6>User Emails :-</h6>
          </label>
          <div class="d-flex flex-wrap gap-3">
            <ng-container *ngFor="let t of userEmailList; let j = index">
              <span class="user-email">{{ t.email }} <i class="fa fa-times" (click)="removeEmail(j)"
                  aria-hidden="true"></i></span>
            </ng-container>
          </div>
        </div>

        <!-- <div class="form-group w-100 col-12">
          <label for="templateSelector" class="form-label">
            <h6>Test Email Ids :-</h6>
          </label>
          <div class="d-flex flex-wrap gap-3">
            <input type="text" class="form-control" [(ngModel)]="userEmailIds" placeholder="Enter Email ID" />
          </div>
        </div> -->

        <div class="m-5 row justify-content-center">
          <button class="btn btn-primary" (click)="sendHtmlInMail()">Send Email <i class="fa fa-paper-plane"
              aria-hidden="true"></i></button>
        </div>
      </section>
    </div>
    <div class="col-9 bg-light template">
      <!-- Template creation -->

      <ng-template #dynamicContainer></ng-template>
      <div class="form-group w-50">
        <label for="">Email Subject</label>
        <input type="text" [(ngModel)]="emailSubject" maxlength="100" class="form-control" />
      </div>

      <div class="form-group w-100">
        <label for="">Email Body "Keep style in inline only"</label>
        <div class="email-container">
          <!-- <div class="m-2">
            <app-editor [(innerValue)]="editorEmailBody"></app-editor>
          </div> -->
          <section #EmailBody class="body-mail" contenteditable="true">
            <email-logo *ngIf="templateSection.logo"></email-logo>
            <email-banner *ngIf="templateSection.banner"></email-banner>
            <div [innerHTML]="emailBody" *ngIf="emailBody"></div>
            @for(section of productTypeSection; track section){
            <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px">
              <h2 style="font-size: 24px; margin: 0">{{ splitText(0, section) | titlecase }} {{ splitText(1, section)
                }}:</h2>
              <button class="btn btn-sm btn-danger" (click)="removeSection(section)"><i
                  class="fa-solid fa-trash"></i></button>
            </div>

            <label style="width: 100%" [for]="section">
              <add-product-section [productType]="splitText(0, section)"></add-product-section>
            </label>
            }
            <!-- <add-product-section *ngIf="enableAddProductSection" [productType]="productType1"></add-product-section>
            <add-product-section *ngIf="productType2" [productType]="productType2"></add-product-section>
            <add-product-section *ngIf="productType3" [productType]="productType3"></add-product-section> -->


            <email-footer *ngIf="footerSection" [html]="footerSection"></email-footer>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #TestMail let-modal>
  <div class="modal-body">
    <div class="add_cattt d-flex justify-content-between">
      <h2>Test Mail</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img"
        (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="referral-link">
      <section class="m-4">
        <div class="form-group">
          <input class="form-control" placeholder="Enter Email Address" id="exampleFormControlTextarea1" maxlength="500"
            [(ngModel)]="testEmailId" />
        </div>
      </section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" (click)="sendMail()">Send <i class="fa fa-plane"
              aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>